import UAParser from 'ua-parser-js';

export default () => {
  const parser = new UAParser(window.navigator.userAgent);
  const browser = parser.getBrowser().name || 'Browser';
  const os = parser.getOS().name || 'Unknown OS';
  const deviceModel = parser.getDevice().model || null;
  const deviceInfo = `${browser} • ${os}${deviceModel ? ` • ${deviceModel}` : ''}`;
  const appName = window.__APP_CONFIG__?.appName ?? '';
  return `${appName} • ${deviceInfo}`;
};
